class ScCurrencySelector extends HTMLElement {
    #applying = false;
    #floatingWidget;
    #observer = new MutationObserver(() => this.#mount());
    connectedCallback() {
      this.addEventListener('change', this.#change);
      this.#mount();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.#change);
      this.#observer.disconnect();
      if (this.#floatingWidget?.parentElement === this) document.body.append(this.#floatingWidget);
    }
    #mount() {
      this.#observer.disconnect();
      if (this.querySelector('#bucksSelector')) {
        this.#observer.observe(this, { childList:true, subtree:true });
        return;
      }
      this.#observer.observe(document.body, { childList:true, subtree:true });
      const floatingWidget = document.querySelector('.buckscc-floating-box');
      if (!floatingWidget?.querySelector('#bucksSelector')) return;
      this.#floatingWidget = floatingWidget;
      this.append(floatingWidget);
      this.#observer.disconnect();
      this.#observer.observe(this, { childList:true, subtree:true });
    }
    #change = (event) => {
      if (this.#applying || !(event.target instanceof HTMLSelectElement) || event.target.id !== 'bucksSelector') return;
      const requestedCurrency = event.target.value;
      const choice = this.querySelector(`.buckscc-select-options li.converterTriggers:not(.geoCurrency)[rel="${CSS.escape(requestedCurrency)}"]`);
      if (!choice) return;
      this.#applying = true;
      try {
        choice.click();
        event.target.value = requestedCurrency;
      } finally {
        this.#applying = false;
      }
    };
  }
  if (!customElements.get('sc-currency-selector')) customElements.define('sc-currency-selector', ScCurrencySelector);
